import { Avatar, Chip, Modal } from "@mui/material";
import React from "react";
import { useNavigate } from "react-router-dom";
import eyeIcon from "../images/eye-icon-black.png";

import ChipStaffName from "./ChipStaffName";
import ChipStatus from "./ChipStatus";
import RoomNumber from "./RoomNumber";
import AlertComponentMobile from "./AlertComponentMobile";
import { getRehabByClient } from "../api/rehabs";
import "./ClientCardCompactRedesign.css";

export default function ClientWidgetMobile(props) {
  const navigate = useNavigate();
  // const showIfEmpty = (value) => {
  //   return value ? value : "------";
  // };

  const showIfEmpty = (value, projectedValue) => {
    if (projectedValue) return projectedValue;
    return value ? value : "------";
  };

  const hasMobileUid = !!String(props.mobileUid || "").trim();
  const rehab = getRehabByClient(props);
  const rehabCode = rehab?.country === "Philippines" ? "PH" : "TH";

  const [openModal, setOpenModal] = React.useState(false);

  const handleOpenModal = () => {
    setOpenModal(true);
  };

  const handleCloseModal = () => {
    setOpenModal(false);
  };

  const handleNavigate = () => {
    navigate(`/client/${props.docId}`, {
      state: props,
    });
  };

  const alertCounts = {
    reminders: 0,
    allergies: 0,
    alerts: 0,
  };

  props.alerts.forEach((alert) => {
    switch (
      alert.type // Remplacez "type" par la cl?? correcte pour le type d'alerte
    ) {
      case 1:
        alertCounts.reminders += 1;
        break;
      case 2:
        alertCounts.allergies += 1;
        break;
      case 3:
        alertCounts.alerts += 1;
        break;
      default:
        break;
    }
  });

  console.log("status in widget: ", props.clientStatus);

  return (
    <div className="client-widget-container-mobile">
      <span
        className={`client-rehab-badge client-rehab-badge-${rehabCode.toLowerCase()}`}
        title={rehab?.name}
      >
        {rehabCode}
      </span>
      <div className="line1-client-widget">
        <div className="left-line-top-widget">
          <div className="left-top-30">
            <ChipStatus
              status={showIfEmpty(props.clientStatus)}
              rehabId={props.rehabId}
              rehabCountry={props.rehabCountry}
            />
            <div onClick={handleOpenModal}>
              <Avatar
                src={props.profilePic}
                style={{
                  width: "42px",
                  height: "42px",
                  marginLeft: "0px",
                  marginTop: "3px",
                  cursor: "pointer",
                }}
              />
            </div>
          </div>
          <div className="left-top-70">
            <div className="widget-firstname">
              {showIfEmpty(props.firstnameClient)}
            </div>
            <div className="widget-lastname">
              {showIfEmpty(props.lastnameClient)}
            </div>
          </div>
        </div>
        <div className="right-line-widget2">
          <div className="client-widget-info-text2">
            {showIfEmpty(props.clientIdentifier)}
          </div>
          <div
            className="client-widget-info-text2"
            title="As Known As : Nickname"
          >
            AKA: {showIfEmpty(props.aka)}
          </div>
          <div className="client-widget-info-text2">
            Age: {showIfEmpty(props.age)}{" "}
          </div>
        </div>
      </div>
      <div className="line2-client-widget">
        <div className="left-line-widget-column">
          <div className="client-widget-info-text3">
            Arrival date: {showIfEmpty(props.arrivalDate)}
          </div>
          <div
            className="client-widget-info-text3"
            title="Intended Discharge Date"
          >
            I.D.D. :{" "}
            {showIfEmpty(props.idd, props.projectedResidentialDischargeDate)}
          </div>
          <div
            className="client-widget-info-text3"
            title="Intended Length of Stay"
            style={{
              display: "flex",
              alignItems: "center",
              gap: 8,
              flexWrap: "wrap",
            }}
          >
            <span>I.L.S. : {showIfEmpty(props.ils)}</span>
            {hasMobileUid && (
              <Chip
                label="Mobile active"
                size="small"
                sx={{
                  height: 22,
                  background:
                    "linear-gradient(90deg, #0f766e 0%, #14b8a6 100%)",
                  color: "#fff",
                  fontWeight: 700,
                  fontSize: "0.66rem",
                }}
              />
            )}
          </div>
        </div>
        <div className="right-line-widget3-column-mobile">
          {alertCounts.reminders > 0 && (
            <AlertComponentMobile
              text={`Reminders: ${alertCounts.reminders}`}
            />
          )}

          {alertCounts.allergies > 0 && (
            <AlertComponentMobile
              text={`Allergies: ${alertCounts.allergies}`}
            />
          )}

          {alertCounts.alerts > 0 && (
            <AlertComponentMobile text={`Alerts: ${alertCounts.alerts}`} />
          )}
        </div>
      </div>
      <div className="line3-client-widget">
        <div className="left60-line-widget-mobile">
          <div className="left1-line-widget-mobile">
            <ChipStaffName
              assignedTherapist={showIfEmpty(props.assignedTherapist)}
            />
          </div>
          <div className="left2-line-widget-mobile">
            <RoomNumber roomNumber={showIfEmpty(props.roomNumber)} />
          </div>
        </div>
        {/* <div className="right40-line-widget"></div> */}
      </div>
      <div className="line4-client-widget">
        {" "}
        <div className="left50-line-widget-mobile">
          <img alt="" className="eye-icon" src={eyeIcon} />
          <button
            className="link-widget"
            type="button"
            onClick={handleNavigate}
          >
            <p className="title-text-button-widget-mobile"> View profile</p>
          </button>
        </div>
        {/* <div className="right50-line-widget">
          <img alt="" className="notes-icon" src={notesIcon} />
          <p className="title-text-button-widget"> Add quick note</p>
        </div> */}
      </div>

      <Modal
        open={openModal}
        onClose={handleCloseModal}
        aria-labelledby="modal-image"
        aria-describedby="image-full-size"
      >
        <div
          onClick={handleCloseModal}
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            width: "100%",
            height: "100%",
            position: "absolute",
            top: 0,
            left: 0,
            backgroundColor: "rgba(0, 0, 0, 0.3)",
          }}
        >
          <img
            src={props.profilePic}
            alt="Full-size profile"
            style={{
              maxWidth: "90%",
              maxHeight: "90%",
              objectFit: "contain",
            }}
          />
        </div>
      </Modal>
    </div>
  );
}

